import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { View } from '@amzn/stencil-react-components/layout';
import { LaasClientId } from '@amzn/myhr-ui-commons';
import { LIVE_HELP_WIDGET_ROOT_ID, isCurrentSessionMyHR } from '@amzn/myhr-livehelp-ui';
import { ATOZ_ROOT_CLASS_NAME, PREFERRED_LANGUAGE_DOM_ATTRIBUTE, REQUIRED_DOM_ATTRIBUTES } from '../consts/constants';
import LanguagesAvailable from '../enums/localisation';

export interface ILiveHelpDOMProps {
  children: ReactNode;
  clientId: LaasClientId;
  pageName: string;
  preferredLanguage?: LanguagesAvailable;
}

export const LiveHelpDOM = ({ children, clientId, pageName, preferredLanguage }: ILiveHelpDOMProps) => {
  const [isDOMInitialized, setIsDOMInitialized] = useState<boolean>(false);
  const [dataset, setDataset] = useState({});
  const [isMyHRsession, setIsMyHRSession] = useState<boolean>(false);

  const filterAttributes = useCallback(
    (attributes: NamedNodeMap) => {
      let filteredAttributes = {};
      Array.from(attributes).forEach((data: Attr) => {
        if (!REQUIRED_DOM_ATTRIBUTES.includes(data.name)) {
          return;
        }
        if (preferredLanguage && data.name === PREFERRED_LANGUAGE_DOM_ATTRIBUTE) {
          return;
        }
        filteredAttributes = {
          ...filteredAttributes,
          [data.name]: data.value,
        };
      });
      return filteredAttributes;
    },
    [preferredLanguage],
  );

  const updateDataset = useCallback((): void => {
    let newDataset = {};
    const atozDoms = document.getElementsByClassName(ATOZ_ROOT_CLASS_NAME);
    Array.from(atozDoms).forEach((dom: Element) => {
      newDataset = {
        ...newDataset,
        ...filterAttributes(dom.attributes),
      };
    });
    setDataset(newDataset);
    setIsDOMInitialized(true);
  }, [filterAttributes]);

  useEffect(() => {
    updateDataset();
  }, [updateDataset]);

  useEffect(() => {
    setIsMyHRSession(isCurrentSessionMyHR());
  }, [clientId]);

  return (
    <View
      id={LIVE_HELP_WIDGET_ROOT_ID}
      data-client-id={clientId}
      data-is-myhr-session={isMyHRsession}
      data-page-name={pageName}
      data-locale={preferredLanguage}
      {...dataset}
    >
      {isDOMInitialized && children}
    </View>
  );
};
